import React from 'react';
import { List, Datagrid, TextField, DateField, NumberField, ChipField, BooleanField, EditButton, TextInput, Filter, SelectInput } from 'react-admin';
import './activities.scss';
import results from './results';

const ActivityFilter = (props) => (
    <Filter {...props}>
        <SelectInput source="result" choices={results} disableValue="not_available" />
        <TextInput label="Airport" source="airport"  />
        <TextInput label="Flio track id" source="flio_track_id"  />
    </Filter>
);

const ResultField = ({ source, record = {} }) => <span className={"result-field result-field_" + record.result}>{record.result}</span>;

export const ActivityList = props => (
    <List {...props} filters={<ActivityFilter />} >
        <Datagrid rowClick="show">
            <TextField source="id" />
            <TextField source="airport" />
            <ResultField source="result" />
            <DateField source="updated_at" />
            <EditButton />
        </Datagrid>
    </List>
);

export default ActivityList;
